import * as i18n from "util/i18n";

import { isMassEcheqManagementAdmitEnabled, isMassEcheqManagementPayEnabled } from "./massEcheqManagementFlags";
import { MANAGEMENT_ACTION_ADMIT, MANAGEMENT_ACTION_PAY } from "./echeqMassManageUtils";

export const createI18nLabelResolver = () => (key) => i18n.get(key);

export const resolveMassEcheqManagementCapabilities = (permissions = {}) => {
    const canAdmit = !!permissions.massiveEcheqManageAdmit && isMassEcheqManagementAdmitEnabled();
    const canPay = !!permissions.massiveEcheqManagePay && isMassEcheqManagementPayEnabled();

    return {
        canAdmit,
        canPay,
        canCreateBatch: canAdmit || canPay,
    };
};

export const buildDownloadExampleOptions = (permissions, formId) => {
    const { canAdmit, canPay } = resolveMassEcheqManagementCapabilities(permissions);
    const options = [];

    if (canAdmit) {
        options.push({
            id: MANAGEMENT_ACTION_ADMIT,
            labelKey: `${formId}.downloadExample.admit`,
        });
    }

    if (canPay) {
        options.push({
            id: MANAGEMENT_ACTION_PAY,
            labelKey: `${formId}.downloadExample.pay`,
        });
    }

    return options;
};

/**
 * Desktop loads any page; mobile infinite scroll only requests forward pages.
 */
export const createPaginatedLoadHandlers = ({ isDesktop, currentPage, onLoadPage }) => {
    const handlePageChange = (page) => {
        onLoadPage(page);
    };

    const handleMobilePageChange = (page) => {
        if (page > currentPage) {
            onLoadPage(page);
        }
    };

    return {
        handlePageChange,
        handleMobilePageChange,
        paginationAction: isDesktop ? handlePageChange : handleMobilePageChange,
    };
};
